import { render, staticRenderFns } from "./DnOrcidIntegration.vue?vue&type=template&id=7c51838f&scoped=true&"
import script from "./DnOrcidIntegration.vue?vue&type=script&lang=js&"
export * from "./DnOrcidIntegration.vue?vue&type=script&lang=js&"
import style0 from "./DnOrcidIntegration.vue?vue&type=style&index=0&id=7c51838f&lang=scss&scoped=true&"
import style1 from "./DnOrcidIntegration.vue?vue&type=style&index=1&id=7c51838f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c51838f",
  null
  
)

export default component.exports